import type { ZodiacSign } from "@/features/advisors"
import { getZodiacSign } from "@/features/user"
import { useQuizStore } from "@/stores/quiz-store"

/**
 * The user's zodiac sign (Today nav icon), derived from the quiz birth date.
 * Falls back to a default sign when the date isn't available yet.
 */
export function useUserZodiac(): ZodiacSign {
  const dob = useQuizStore((s) => s.answers.dob)
  if (typeof dob === "string") {
    const sign = getZodiacSign(dob)
    if (sign) return sign
  }
  return "Aries"
}
